import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { logout } from "./store/slices/adLoginSlice"; // Assuming adLoginSlice handles admin login state
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function ProtRoute({ children }) {
  const isLoggedIn = useSelector((state) => state.adLogin.isLoggedIn); // Check login status from Redux
  const dispatch = useDispatch();

  const idleTimeout = 15 * 60 * 1000; // 15 minute

  // Memoize handleLogout to avoid recreating the function on every render
  const handleLogout = useCallback(() => {
    toast.warning("Session timed out. Please log in again.");

    // Delay the actual logout and redirect by 1 second to allow the toast to show
    setTimeout(() => {
      dispatch(logout()); // Dispatch logout action
    }, 3000); // Delay for 3 second
  }, [dispatch]);

  // Memoize resetIdleTimer to avoid recreating the function on every render
  const resetIdleTimer = useCallback(() => {
    if (window.idleTimer) {
      clearTimeout(window.idleTimer);
    }
    window.idleTimer = setTimeout(() => {
      handleLogout();
    }, idleTimeout);
  }, [handleLogout, idleTimeout]);

  useEffect(() => {
    if (isLoggedIn) {
      window.idleTimer = setTimeout(handleLogout, idleTimeout);

      window.addEventListener('mousemove', resetIdleTimer);
      window.addEventListener('keydown', resetIdleTimer);
      window.addEventListener('scroll', resetIdleTimer);
      window.addEventListener('click', resetIdleTimer);

      return () => {
        clearTimeout(window.idleTimer);
        window.removeEventListener('mousemove', resetIdleTimer);
        window.removeEventListener('keydown', resetIdleTimer);
        window.removeEventListener('scroll', resetIdleTimer);
        window.removeEventListener('click', resetIdleTimer);
      };
    }
  }, [isLoggedIn, handleLogout, resetIdleTimer, idleTimeout]);

  if (!isLoggedIn) {
    return <Navigate to="/loginFA" />; // Redirect to login if not authenticated
  }

  return (
    <>
      <ToastContainer position="top-center" autoClose={5000} />
      {children}
    </>
  );
}
